import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import CookiePrivacyPolicyPopup from "@insite/content-library/Components/CookiePrivacyPolicyPopup";
import Page from "@insite/mobius/Page";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

// Opted to keep the same customization rather than refactor to make use of the MobiusPageProps from update 5.0.11.305
export interface FooterStyles {
    container?: InjectableCss;
    footerPage?: InjectableCss;
}

const styles: FooterStyles = {
    container: {
        css: css`
            background-color: ${getColor("primary.main")};
        `,
    },
    footerPage: {
        css: css`
            background-color: ${getColor("primary.main")};
        `,
    },
};

const Footer = ({ id }: PageProps) => (
    <StyledWrapper {...styles.container}>
        <Zone contentId={id} zoneName="TopFullWidthFooter" />
        <Page as="footer" isFooter={true} style={{ paddingTop: 25 }} {...styles.footerPage}>
            <Zone contentId={id} zoneName="Content" />
            <CookiePrivacyPolicyPopup />
        </Page>
        <Zone contentId={id} zoneName="BottomFullWidthFooter" />
    </StyledWrapper>
);

const pageModule: PageModule = {
    component: Footer,
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        pageType: "System",
    },
};

export default pageModule;
export const FooterContext = "Footer";
